import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>For example, someone might say: <span className="subtiltereg">‘I need the rolls now’</span>.
                                            </p>
                                            <p>Depending on the circumstances in which these words are heard,
                                                you could interpret them to mean:</p>
                                            <ul className="greenbullet-list1">
                                                <li><p style={{paddingBottom:'0px'}}><span
                                                    className="brown boldtext listencolor"
                                                    style={{paddingRight: '13px'}}>1.</span>It’s someone talking to
                                                    their chauffeur.<br/>
                                                                <span className="contentspacing"
                                                                      style={{paddingLeft: '24px'}}>Meaning: <span
                                                                    className="subtiltereg">Rolls Royce.</span></span>
                                                </p></li>
                                                <li><p style={{paddingBottom:'0px'}}><span
                                                    className="brown boldtext listennumber">2.</span><span>Service at your local Chinese restaurant is particularly slow, tonight.</span>
                                                    <span className="contentspacing meaning">Meaning:<span
                                                        className="subtiltereg"> Spring rolls.</span></span></p>
                                                </li>
                                                <li><p style={{paddingBottom:'0px'}}><span
                                                    className="brown boldtext listennumber">3.</span><span>You are practising for a rock show and you are speaking to your drummer.</span>
                                                    <span className="contentspacing meaning">Meaning: <span
                                                        className="subtiltereg">Drum rolls.</span></span></p>
                                                </li>
                                            </ul>
                                            <p>So, meaning is determined ‘contextually’!</p>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">WHY IS ACTIVE LISTENING IMPORTANT?</span>
                                            </div>

                                            <p>Studies of relationships in the workplace consistently reveal
                                                that staff often feel their managers don’t listen to them. The
                                                role of manager can be hectic because of the need to assimilate
                                                information from different sources, quickly. Too often, it means
                                                insufficient time is given to listening to what is really being
                                                said.</p>
                                            <p>The benefits of active listening include encouraging people to
                                                ‘open up’, avoiding misunderstandings, resolving conflict and
                                                building trust. It’s also key to picking up information which
                                                might otherwise be overlooked.</p>
                                            <div className="border_subtitle">What gets in the way of active
                                                listening?
                                            </div>

                                            <p>Because we think a lot faster than someone can speak, our minds
                                                wander as we listen. In all communication, there are barriers
                                                between ‘sender’ and ‘receiver’ which hinder the process.
                                                However, just being aware of them will help you listen more
                                                effectively:</p>
                                            <div className="border_subtitle">There are four types of barriers to
                                                listening:<a className="superscripttext"
                                                             href="further_info.php?course=300"><sup>5</sup></a>
                                            </div>
                                            <ul className="greenbullet-list1">
                                                <li><span
                                                    className="brown boldtext listencolor barrier">1.</span><span
                                                    className="subtiltereg barrier">Psychological</span><br/><p
                                                    style={{paddingBottom:'0px'}}><span
                                                    className="contentspacing spacing1"
                                                    style={{paddingLeft:'27px !important'}}>This may include fear, prejudice or lack of interest. For example, if you work in marketing you’re probably not as interested in the company’s annual figures as the finance director (but desperate to know how your presentation went). It’s about how or whether what is being said impacts your day-to-day activities or interests.</span>
                                                </p></li>
                                                <li><span
                                                    className="brown boldtext listencolor barrier">2.</span><span
                                                    className="subtiltereg barrier">Physical</span><br/><p
                                                    style={{paddingBottom:'0px'}}><span
                                                    className="contentspacing spacing1"
                                                    style={{paddingLeft:'27px !important'}}>Disability, fatigue or ill health on the part of the listener. For example, suffering a cold, with blocked sinuses and streaming eyes is not conducive to listening to anyone, at all.</span>
                                                </p></li>
                                                <li><span
                                                    className="brown boldtext listencolor barrier">3.</span><span
                                                    className="subtiltereg barrier">Environmental</span><br/><p
                                                    style={{paddingBottom:'0px'}}><span
                                                    className="contentspacing spacing1"
                                                    style={{paddingLeft:'27px !important'}}>Distracting noises, uncomfortable seating, or an overheated, stuffy room.</span>
                                                </p></li>
                                                <li><span
                                                    className="brown boldtext listencolor barrier">4.</span><span
                                                    className="subtiltereg barrier">Expectation</span><br/><p
                                                    style={{paddingBottom:'0px'}}><span
                                                    className="contentspacing spacing1"
                                                    style={{paddingLeft:'27px !important'}}>Expecting this afternoon’s talk to be really boring! Anticipating bad news. Being spoken to in confusing jargon.</span>
                                                </p></li>

                                            </ul>

                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}